import {
  LOAD_BRIEFCASES,
  LOADING_BRIEFCASES,
  ERROR_BRIEFCASES,
} from "./briefcaseTypes";

const initial = {
  briefcases: [],
  loading: true,
  error: false,
};

const briefcaseReducer = (state = initial, action) => {
  switch (action.type) {
    case LOADING_BRIEFCASES:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case LOAD_BRIEFCASES:
      return {
        briefcases: action.payload,
        loading: false,
        error: false,
      };
    case ERROR_BRIEFCASES:
      return {
        briefcases: [],
        loading: false,
        error: true,
      };
    default:
      return state;
  }
};

export default briefcaseReducer;
